import React from 'react';
import { connect } from 'react-redux';
import EditLeaderboardForm from './EditLeaderboardForm'
import { Modal } from 'reactstrap';

const EditLeaderboardModal = ({program, organization, leaderboard, isOpen, toggle, rtl, theme}) => {

  const props = {
    data: leaderboard,
    program,
    organization,
    rtl,
    theme,
    toggle
  };

  return (
    <Modal className={`${theme.className} ${rtl.direction}-support program-settings manager-program-settings-modal modal-xl`} isOpen={isOpen} toggle={toggle}>
      <div className="manager-program-settings-modal__layout">
        <div className="manager-program-settings-modal__main">
          <div className="manager-program-settings-modal__header">
            <div className="manager-program-settings-modal__header-copy">
              <h3 className="manager-program-settings-modal__title">Edit Leaderboard</h3>
              <p className="manager-program-settings-modal__subtitle">
                Update leaderboard settings and assignments.
              </p>
            </div>
            <button
              type="button"
              className="manager-program-settings-modal__close"
              onClick={toggle}
              aria-label="Close"
            >
              Close
            </button>
          </div>
          <div className="manager-program-settings-modal__body">
            <EditLeaderboardForm {...props} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
     rtl: state.rtl,
     theme: state.theme
  };
};

export default connect(mapStateToProps)(EditLeaderboardModal);
